import { defineMessages } from 'react-intl';

export default defineMessages({
  returnsConfigurationTitle: {
    description: 'Title displayed in the header of the returns configuration iframe modal',
    defaultMessage: 'Returns Configuration',
    id: 'YTEpvI',
  },
  ssoTokenError: {
    description: 'Error notification shown when the SSR single sign-on token request fails',
    defaultMessage: 'Unable to open Returns Configuration. Please try again.',
    id: 'DxEnHE',
  },
});
